import React from "react";
import {
  Button,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  useTheme,
} from "@mui/material";

export type ConfirmationModalProps = {
  open: boolean;
  message: React.ReactNode;
  handleClose: () => void;
  onConfirm: () => void;
};

const ConfirmationModal = (props: ConfirmationModalProps) => {
  const theme = useTheme();

  // OKボタンが押下時の処理
  const handleOk = () => {
    props.onConfirm();
    props.handleClose();
  };
  // キャンセルボタン押下時の処理
  const handleCancel = () => {
    props.handleClose();
  };

  return (
    <Box>
      <Dialog
        open={props.open}
        onClose={props.handleClose}
        PaperProps={{
          sx: {
            width: { xs: "50vw", md: "30vw", lg: "30vw" },
            maxWidth: { xs: "50vw", md: "30vw", lg: "30vw" },
            height: { xs: "30vh", lg: "30vh" },
            maxHeight: { xs: "30vh", lg: "30vh" },
            backgroundColor: theme.palette.custom.sForm,
          },
        }}
      >
        <DialogTitle>Message</DialogTitle>
        <DialogContent
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            whiteSpace: "pre-line",
          }}
        >
          {props.message}
        </DialogContent>

        <DialogActions
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: 0.5,
          }}
        >
          <Button
            onClick={handleCancel}
            variant="outlined"
            color="secondary"
            sx={{ width: { xs: "100%", md: "50%", lg: "30%" } }}
          >
            キャンセル
          </Button>
          <Button
            onClick={handleOk}
            variant="contained"
            color="primary"
            sx={{ width: { xs: "100%", md: "50%", lg: "30%" } }}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default ConfirmationModal;
